export default "__VITE_ASSET__DxO5v1DC__"